import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterOutlet } from "@angular/router";
import { AccountSelectionService } from "@front/m19-services";
import { AccessLevel } from "libs/m19-services/src/lib/api-client/models";
import { DspAdvertiserRequestService } from "libs/m19-services/src/lib/m19-services/dspAdvertiserRequest.service";
import { map, of, switchMap } from "rxjs";
import { RequestCreationStatusPageComponent } from "./dsp-advertiser-request-page/request-creation-status-page.component";

@Component({
  selector: "app-dsp-layout",
  imports: [RouterOutlet, RequestCreationStatusPageComponent],
  template: `
    @if (dspAdvertiserRequest() && !dspAdvertiserId()) {
      <app-request-creation-status-page [dspAdvertiserRequest]="dspAdvertiserRequest()!" />
    } @else {
      <router-outlet />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspLayoutComponent {
  private readonly accountSelectionService = inject(AccountSelectionService);
  private readonly dspAdvertiserRequestService = inject(DspAdvertiserRequestService);

  private readonly isAdmin$ = this.accountSelectionService.singleAccountMarketplaceSelection$.pipe(
    map((accountSelection) => accountSelection.accessLevel === AccessLevel.ADMIN),
  );

  protected readonly dspAdvertiserRequest$ = this.isAdmin$.pipe(
    switchMap((isAdmin) => {
      if (isAdmin) {
        return this.dspAdvertiserRequestService.dspAdvertiserRequest$;
      }
      return of(undefined);
    }),
  );

  protected readonly dspAdvertiserRequest = toSignal(this.dspAdvertiserRequest$);

  dspAdvertiserId = toSignal(
    this.accountSelectionService.singleAccountMarketplaceSelection$.pipe(
      map((accountSelection) => accountSelection.dspAdvertiserId),
    ),
  );
}
